/*----------------------------------
- LANDING: CTA TRACKING
----------------------------------*/

import { track } from '@/client/pages/landing/lib/analytics';

/*----------------------------------
- TYPES
----------------------------------*/

type LandingCtaTrackingInput = {
    page: string;
    section: string;
    label: string;
    kind: string;
    href?: string;
    feature?: string;
    action?: string;
    surface?: string;
};

/*----------------------------------
- PUBLIC API
----------------------------------*/

export const trackLandingCta = ({
    page,
    section,
    label,
    kind,
    href,
    feature,
    action,
    surface = 'landing',
}: LandingCtaTrackingInput) => {
    track('landing_cta_click', {
        page,
        section,
        label,
        kind,
        href,
        feature,
        action,
        surface,
    });
};
